import React from 'react';
import { Form} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

export default function CustomCheckbox(props) {
    return(
        <>
        <Form.Group controlId={props?.id}>

        <Form.Check type="checkbox" label={props.label || 'Check'} onChange={props?.onChange} />
        <Form.Text className="text-danger">
          {props.errorText}
        </Form.Text>
      </Form.Group>
      </>
    )
}